<template>
  <component :is="logo" />
</template>
<script setup lang="ts">
import { computed } from "vue";

import type { IconName } from "./icons/iconNames.generated";
import { iconRegistry } from "./icons/iconRegistry";

const LOGOS = {
  mark: "generic/scayla-logo",
  wordmark: "generic/scayla-logo-text",
} as const satisfies Record<string, IconName>;

/** Sized by the caller's CSS (a height or a width, the other follows the drawing); painted with `color`. */
const props = defineProps<{
  variant: keyof typeof LOGOS;
}>();

const logo = computed(() => iconRegistry.get(LOGOS[props.variant]));

defineOptions({
  name: "SCALogo",
});
</script>
